// Same in Web.
export enum DocumentType {
	None,
	Project,
	Portfolio,
	WbsComponent,
	Organization,
	WorkItem
}
